module.exports = "/_next/static/images/10a21ac659550fdd6c2941cd7ec275ab-nuconta-inclined-device@3x.png.webp";